import React from 'react';
import Svg, { Path } from 'react-native-svg';
/**
 * SF Symbols-style chevron (chevron.left / chevron.right, semibold), drawn
 * with react-native-svg so it looks the same on iOS, Android and web.
 */
export const ChevronIcon = ({ direction, size = 16, color, }) => (<Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Path d={direction === 'back'
        ? 'M15 4.5 7.5 12 15 19.5'
        : 'M9 4.5 16.5 12 9 19.5'} stroke={color} strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
